export const byEventLoggedAt = (a, b) => {
    if (a.eventLoggedAt < b.eventLoggedAt) { return -1; }
    if (a.eventLoggedAt > b.eventLoggedAt) { return 1; }
    return 0;
};
